module.exports = __webpack_public_path__ + "1d76025c27d8656a6df2c3a221e009a7.fbx";